module.exports = __webpack_public_path__ + "static/content_image_2-e6be45fc5f70217a823d019e592a73cf.svg";